'use client';

import { c as _c } from "react/compiler-runtime";
import { FormControl, FormLabel, Stack, Typography, type SxProps } from '@mui/material';
import { useState, type ReactNode } from 'react';
import { HelpIcon } from '@/components/shared/helpIcon';
import type { FieldValidation } from './validation/fieldValidation';
import { InputErrorIcon } from './validation/inputErrorIcon';
export const FormFieldFrame = t0 => {
  const $ = _c(24);
  const {
    title,
    helpText,
    alwaysShowHelp: t1,
    validation,
    value,
    showValidationError: t2,
    sx,
    children
  } = t0;
  const alwaysShowHelp = t1 === undefined ? false : t1;
  const showValidationError = t2 === undefined ? false : t2;
  const [touched, setTouched] = useState(false);
  let t3;
  if ($[0] !== showValidationError || $[1] !== touched || $[2] !== validation || $[3] !== value) {
    t3 = (touched || showValidationError) && (validation ? !validation.validateInput(value) : false);
    $[0] = showValidationError;
    $[1] = touched;
    $[2] = validation;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const hasError = t3;
  let t4;
  if ($[5] !== hasError || $[6] !== validation || $[7] !== value) {
    t4 = hasError ? <InputErrorIcon errorMessage={validation?.errorMessage(value)} /> : null;
    $[5] = hasError;
    $[6] = validation;
    $[7] = value;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const errorAdornment = t4;
  let t5;
  if ($[9] !== sx) {
    t5 = {
      width: "100%",
      ...sx
    };
    $[9] = sx;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== alwaysShowHelp || $[12] !== helpText || $[13] !== title) {
    t6 = title && <FormLabel><Stack direction="row" sx={{
        alignItems: "center",
        justifyContent: "space-between"
      }}><Typography variant="subtitle1">{title}</Typography>{helpText && <HelpIcon title={helpText} alwaysVisible={alwaysShowHelp} className="text-(--mui-palette-text-secondary)" />}</Stack></FormLabel>;
    $[11] = alwaysShowHelp;
    $[12] = helpText;
    $[13] = title;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setTouched(true);
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== children || $[17] !== errorAdornment || $[18] !== hasError) {
    t8 = children({
      hasError,
      errorAdornment,
      onBlur: t7
    });
    $[16] = children;
    $[17] = errorAdornment;
    $[18] = hasError;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t8) {
    t9 = <FormControl className="group/help" sx={t5}>{t6}{t8}</FormControl>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};